import React from 'react';
import { Phone, Mail, MapPin, ArrowUp, ShieldCheck } from 'lucide-react';
import Logo from './Logo';

const Footer = ({ onOpenContact }) => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer style={{ background: '#070a12', borderTop: '1px solid var(--border-glass)', paddingTop: '4rem', paddingBottom: '2rem', color: 'var(--text-muted)' }}>
      <div className="container">
        <div className="grid-4" style={{ gap: '2.5rem', marginBottom: '3rem' }}>
          {/* Col 1: Company Profile */}
          <div style={{ gridColumn: 'span 1' }}>
            <div style={{ marginBottom: '1.25rem', background: '#ffffff', padding: '0.6rem 1rem', borderRadius: '12px', display: 'inline-block', boxShadow: '0 4px 15px rgba(0,0,0,0.2)' }}>
              <Logo size="medium" lightMode={true} />
            </div>

            <p style={{ fontSize: '0.875rem', lineHeight: 1.6, marginBottom: '1.25rem' }}>
              Digital Land Survey & Consulting specializing in DGPS high-accuracy surveys, boundary details, and Water Resources Development (W.R.D.) work.
            </p>

            <div style={{ fontSize: '0.8rem', color: 'var(--accent-gold)', display: 'flex', alignItems: 'center', gap: '0.35rem' }}>
              <ShieldCheck size={15} /> Accurate Survey, Better Tomorrow
            </div>
          </div>

          {/* Col 2: Core Services Links */}
          <div>
            <h4 style={{ color: '#ffffff', fontSize: '1.05rem', marginBottom: '1.25rem' }}>Core Specialties</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.6rem', fontSize: '0.875rem' }}>
              <li><a href="#services" style={{ color: 'var(--text-muted)', textDecoration: 'none' }}>DGPS High-Accuracy Survey</a></li>
              <li><a href="#services" style={{ color: 'var(--text-muted)', textDecoration: 'none' }}>Boundary Survey & Land Details</a></li>
              <li><a href="#services" style={{ color: 'var(--text-muted)', textDecoration: 'none' }}>Water Resources (W.R.D. Work)</a></li>
              <li><a href="#services" style={{ color: 'var(--text-muted)', textDecoration: 'none' }}>Highways, Road Alignment & Volumetric</a></li>
              <li><a href="#services" style={{ color: 'var(--text-muted)', textDecoration: 'none' }}>Topographical Contour Surveys</a></li>
            </ul>
          </div>

          {/* Col 3: Quick Navigation */}
          <div>
            <h4 style={{ color: '#ffffff', fontSize: '1.05rem', marginBottom: '1.25rem' }}>Quick Navigation</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.6rem', fontSize: '0.875rem' }}>
              <li><a href="#hero" style={{ color: 'var(--text-muted)', textDecoration: 'none' }}>Home</a></li>
              <li><a href="#about" style={{ color: 'var(--text-muted)', textDecoration: 'none' }}>About B Digital Land Survey</a></li>
              <li><a href="#calculator" style={{ color: 'var(--text-muted)', textDecoration: 'none' }}>Interactive Cost Estimator</a></li>
              <li><a href="#projects" style={{ color: 'var(--text-muted)', textDecoration: 'none' }}>Project Work Gallery</a></li>
              <li><a href="#equipment" style={{ color: 'var(--text-muted)', textDecoration: 'none' }}>DGPS & Survey Tech Stack</a></li>
              <li><button onClick={() => onOpenContact()} style={{ background: 'none', border: 'none', color: '#e63946', padding: 0, cursor: 'pointer', fontFamily: 'inherit', fontSize: 'inherit', fontWeight: '600' }}>Request Instant Quote</button></li>
            </ul>
          </div>

          {/* Col 4: Contact & Locations */}
          <div>
            <h4 style={{ color: '#ffffff', fontSize: '1.05rem', marginBottom: '1.25rem' }}>Contact & Locations</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.85rem', fontSize: '0.875rem' }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.6rem' }}>
                <MapPin size={18} color="#e63946" style={{ marginTop: '0.15rem', flexShrink: 0 }} />
                <span>Theni District - 625525, Tamil Nadu</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.6rem' }}>
                <MapPin size={18} color="var(--primary-blue)" style={{ marginTop: '0.15rem', flexShrink: 0 }} />
                <span>Serving All Districts Across Tamil Nadu & Pan-India</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                <Phone size={18} color="var(--primary-cyan)" style={{ flexShrink: 0 }} />
                <a href="tel:+919677579748" style={{ color: '#ffffff', textDecoration: 'none', fontWeight: '600' }}>+91 96775 79748</a>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                <Mail size={18} color="var(--accent-gold)" style={{ flexShrink: 0 }} />
                <a href="mailto:bagavathiraja96@gmail.com" style={{ color: 'var(--text-muted)', textDecoration: 'none' }}>bagavathiraja96@gmail.com</a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div
          style={{
            borderTop: '1px solid var(--border-glass)',
            paddingTop: '2rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '1rem',
            fontSize: '0.85rem',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
            <div>
              © {new Date().getFullYear()} B Digital Land Survey & Consulting. All rights reserved.
            </div>
            <div style={{ fontSize: '0.825rem', color: '#94a3b8' }}>
              Powered by{' '}
              <a
                href="https://magizhinitech.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#e63946', fontWeight: '700', textDecoration: 'none', transition: 'opacity 0.2s ease' }}
                onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.8')}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
              >
                Magizhini Technology Services Inc.
              </a>
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <span style={{ color: 'var(--text-subtle)' }}>Accurate Survey, Better Tomorrow</span>
            <button
              onClick={scrollToTop}
              style={{
                background: 'rgba(255, 255, 255, 0.05)',
                border: '1px solid var(--border-glass)',
                color: '#ffffff',
                borderRadius: '50%',
                width: '38px',
                height: '38px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
              }}
              aria-label="Back to top"
            >
              <ArrowUp size={18} />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
